import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ApiUrls } from 'src/app/shared/api-urls';

@Component({
  selector: 'app-lhnd-details',
  templateUrl: './lhnd-details.component.html',
  styleUrls: ['./lhnd-details.component.scss']
})
export class LhndDetailsComponent implements OnInit {

  lhndDetails: any = {};;
  params
  constructor(private http: HttpClient, private activatedRoute: ActivatedRoute,public location:Location,public toastr:ToastrService) { }

  ngOnInit(): void {
    this.params = this.activatedRoute.snapshot.queryParams.id;
    this.http.get(`${ApiUrls.lhdl_settings}/${this.params}`).subscribe((res: any) => {
      if (res) {
        this.lhndDetails = res.data
      }
    })
  }

  /**
   * Determines whether submit on
   * @params form
   */
  onSubmit(form: NgForm): void {
    console.log(form.value)
    if(form.valid){
      const params = this.activatedRoute.snapshot.queryParams.id;
      this.http.put(`${ApiUrls.lhdl_settings}/${params}`, this.lhndDetails).subscribe((res:any) => {
        if(res){
          this.toastr.success('Updated')
          this.ngOnInit()
        }
      })
    }else{
      form.form.markAllAsTouched();
    }
    
  }

}
